
function InfosRecap1({ infos }) { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree

    return (
        <div className="infos-recap1">
            <div className="infos-recap1-ligne-1">
                <p className="infos-recap1-ligne-titre">Point de location :</p>
                <p className="infos-recap1-ligne-info">{infos.spot}</p>
            </div>
            <div className="infos-recap1-ligne-2">
                <p className="infos-recap1-ligne-titre">Dates :</p>
                <p className="infos-recap1-ligne-info">{infos.dates}</p>

            </div>
            <div className="infos-recap1-ligne-3">
                <p className="infos-recap1-ligne-titre">Soit :</p>
                <p className="infos-recap1-ligne-info">{infos.duree}</p>

            </div>


        </div>

    )
}




export default InfosRecap1